import { gateway } from "../../../../gateway";

export const postSupplyProvider = async ({ token, data }) => {
  try {
    const res = await gateway.post(
      `/supplies/providers/`,
      data,
      {
        headers: {
          Authorization: `${token}`,
        },
      }
    );
    return res.data;
  } catch (error) {
    throw error;
  }
};
